import { USER_TYPE_MODEL } from "../../../../enums/userTypeEnum";

export const createMealModel = () => ({
    cafeteriaId: null,
    cafeteriaName: "",
    date: new Date().toISOString(), //set today
    mealTime: null,
    mealTimes: [],
    menuMealTimeIds: [],
    menuMealTimesObj: {
        starter: null,
        side: null,
        main: null,
        dessert: null
    },
    openTime: '',
    closeTime: '',
    latitude: 0,
    longitude: 0,
    servingDate: null,

    isValidMealTimeModal() {
        return this.cafeteriaId !== null && this.date !== "" && this.date !== null && this.mealTime !== null;
    },

    /**
     * Builds the payload to save an order.
     *
     * @function toSaveOrder
     * @param {Object} params - Parameters to build the payload.
     * @param {number} params.requestedByUserTypeId - Type of the user who is making the request.
     * @param {string} params.userId - ID of the user who is making the request.
     * @returns {Object} Order payload.
     */
    toSaveOrder({ requestedByUserTypeId, userId }) {
        return {
            ...this.menuMealTimesObj,
            isExtraRequest: false,
            requestedByUserTypeId,
            userId,
            servingDate: new Date(this.date).getTime(),
        };
    },

    /**
     * Builds the payload to save an extra order.
     *
     * @function toSaveExtraOrder
     * @param {string} foodieRequestId - The ID of the extra meal request.
     * @returns {Object} Extra order payload.
     */
    toSaveExtraOrder(foodieRequestId) {
        return {
            ...this.menuMealTimesObj,
            id: foodieRequestId,
        };
    },
    clearMenuMealsTimes(){
        return {
            ...this,
            menuMealTimeIds: [],
            menuMealTimesObj: {
                starter: null,
                side: null,
                main: null,
                dessert: null
            }
        }
    },
    clear(){
        return {
            ...this,
            cafeteriaId: null,
            cafeteriaName: "",
            date: new Date().toISOString(), //set today
            mealTime: null,
            mealTimes: [],
            menuMealTimeIds: [],
            menuMealTimesObj: {
                starter: null,
                side: null,
                main: null,
                dessert: null
            },
            openTime: '',
            closeTime: '',
            latitude: 0,
            longitude: 0,
            servingDate: null,
        }
    }
});

export const TITLES_MEALS = {
    1: 'select_a_starter',
    2: 'select_main_course',
    3: 'select_side_course',
    4: 'select_dessert'
};


/**
 * Gets the user type based on the provided identifier.
 *
 * @function getUserType
 * @param {Object} params - Object containing possible identifiers.
 * @param {string|null} params.userId - Employee identifier. If provided, returns EMPLOYEE.
 * @param {string|null} params.contractorId - Contractor identifier. If provided, returns CONTRACTOR_IN_CHARGE.
 * @param {string|null} params.supplierId - Supplier identifier. If provided, returns SUPPLIER_IN_CHARGE.
 *
 * @returns {number|null} Returns the user type based on the identifier received,
 * or `null` if none was provided.
 */
export function getUserType({ userId, contractorId, supplierId }) {
    if (userId) {
        return USER_TYPE_MODEL.EMPLOYEE;
    }
    if (contractorId) {
        return USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE;
    }
    if (supplierId) {
        return USER_TYPE_MODEL.SUPPLIER_IN_CHARGE;
    }
    return null; // if all identifiers are null
}
